// Function to show the personalization container
function showPersonalizationContainer() {
    const container = document.querySelector('.product-personalization-container');
    const loadingElement = document.getElementById('personalization-loading');
    if (container) {
        // Hide loading spinner
        if (loadingElement) {
            loadingElement.style.display = 'none';
        }
        // Force reflow to ensure the transition works
        container.offsetHeight;
        container.style.display = 'block';
        console.log('Personalization container shown');
    } else {
        console.warn('Personalization container not found');
        if (loadingElement) {
            loadingElement.style.display = 'none';
        }
    }
}

// Show container when everything is loaded
// window.addEventListener('load', function() {
//     console.log('Page fully loaded, showing personalization container');
//     showPersonalizationContainer();
// });
// Show container when AdditionalData is ready
document.addEventListener('additionalDataReady', function () {
    showPersonalizationContainer();
});

document.addEventListener('DOMContentLoaded', function () {
    class PriceUpdater {
        /**
         * 初始化价格元素，解析并存储原始价格信息
         * @param {HTMLElement} priceElement 价格元素
         */
        static init(priceElement) {
            if (priceElement.hasAttribute('data-base-price')) {
                return; // 已初始化则直接返回
            }

            const originalFull = priceElement.textContent.trim();
            console.log('原始价格文本:', originalFull);

            // 提取价格数字部分
            const priceMatch = originalFull.match(/(\d+[,.\d]*)/);
            if (!priceMatch) return;

            const priceStr = priceMatch[1];
            console.log('提取的价格字符串:', priceStr);

            // 判断千位分隔符和小数点
            let thousandSep = '';
            let decimalSep = '';
            let decimalPart = '00';
            let integerPart = '';

            // 检查有多少个逗号和点
            const commaCount = (priceStr.match(/,/g) || []).length;
            const dotCount = (priceStr.match(/\./g) || []).length;

            // 确定分隔符类型 - 保留原有详细逻辑
            if (commaCount === 1 && dotCount === 0) {
                // 只有一个逗号，且没有点 - 很可能是小数点（欧洲格式）
                decimalSep = ',';
                const parts = priceStr.split(',');
                integerPart = parts[0];
                decimalPart = parts[1] || '00';
            } else if (dotCount === 1 && commaCount === 0) {
                // 只有一个点，没有逗号 - 很可能是小数点（英美格式）
                decimalSep = '.';
                const parts = priceStr.split('.');
                integerPart = parts[0];
                decimalPart = parts[1] || '00';
            } else if (commaCount > 0 && dotCount === 0) {
                // 多个逗号，没有点 - 逗号是千位分隔符
                thousandSep = ',';
                integerPart = priceStr.replace(/,/g, '');
            } else if (dotCount > 0 && commaCount === 0) {
                // 多个点，没有逗号 - 点是千位分隔符
                thousandSep = '.';
                integerPart = priceStr.replace(/\./g, '');
            } else if (commaCount > 0 && dotCount > 0) {
                // 既有逗号也有点 - 最后出现的是小数点
                if (priceStr.lastIndexOf(',') > priceStr.lastIndexOf('.')) {
                    decimalSep = ',';
                    thousandSep = '.';
                    const parts = priceStr.split(',');
                    integerPart = parts[0].replace(/\./g, '');
                    decimalPart = parts[1] || '00';
                } else {
                    decimalSep = '.';
                    thousandSep = ',';
                    const parts = priceStr.split('.');
                    integerPart = parts[0].replace(/,/g, '');
                    decimalPart = parts[1] || '00';
                }
            } else {
                // 没有逗号和点 - 整数
                integerPart = priceStr;
            }

            // 确保小数部分是两位
            decimalPart = decimalPart.padEnd(2, '0').substring(0, 2);

            // 计算基础价格数值（转换为浮点数）
            const originalVal = parseFloat(`${integerPart}.${decimalPart}`);
            console.log('解析的整数部分:', integerPart, '小数部分:', decimalPart, '原始数值:', originalVal);

            // 存储所有需要的信息
            priceElement.setAttribute('data-base-price', originalVal);
            priceElement.setAttribute('data-original-full', originalFull);
            priceElement.setAttribute('data-thousand-sep', thousandSep);
            priceElement.setAttribute('data-decimal-sep', decimalSep);
            priceElement.setAttribute('data-original-decimal', decimalPart);
            priceElement.setAttribute('data-price-pattern', priceMatch[0]);
        }

        /**
         * 格式化数字并添加分隔符
         * @param {number} num 要格式化的数字
         * @param {string} thousandSep 千位分隔符
         * @param {string} decimalSep 小数分隔符
         * @param {string} decimalPart 小数部分
         * @returns {string} 格式化后的数字字符串
         */
        static formatNumberWithSeparators(num, thousandSep, decimalSep, decimalPart) {
            // 处理整数部分
            let integerPart = Math.floor(num).toString();

            // 添加千位分隔符
            if (thousandSep) {
                integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSep);
            }

            // 组合整数和小数部分
            return decimalSep ? `${integerPart}${decimalSep}${decimalPart}` : integerPart;
        }

        static updatePromotionPrice(priceElement, newPriceVal, thousandSep, decimalSep, pricePattern, originalFull) {
            const promotionPriceElement = document.querySelector('.promotion-price.promotion-price--signa-silver');
            if (!promotionPriceElement) return false;

            const saleRegularPrice = document.querySelector('.price__sale s.price-item--regular').innerHTML.trim() === '';
            const shouldUpdate = saleRegularPrice ?  priceElement.classList.contains('price-item--regular') : priceElement.classList.contains('price-item--last');
            if (shouldUpdate) {
                const promotionPriceVal = Number(Math.floor((newPriceVal / 2) * 100) / 100);
                const decimalPartForFormat = (promotionPriceVal % 1).toFixed(2).split('.')[1];
                const formatedPromotionPrice = PriceUpdater.formatNumberWithSeparators(promotionPriceVal, thousandSep, decimalSep, decimalPartForFormat);
                const newPriceStr = originalFull.replace(pricePattern, formatedPromotionPrice);
                console.log("Update Promotion Price: ", newPriceVal, promotionPriceVal, formatedPromotionPrice, newPriceStr)
                promotionPriceElement.querySelector("span.value").innerHTML = newPriceStr;
            }
        }

        /**
         * 更新价格
         * @param {HTMLElement} priceElement 价格元素
         * @param {number} additionalAmount 附加金额（元）
         */
        static updatePrice(priceElement, additionalAmount, includeBasePrice = true) {
            // 初始化价格信息
            PriceUpdater.init(priceElement);

            // 检测是否是炼金戒指产品
            // 如果是炼金戒指，强制使用 includeBasePrice=false
            // 因为 additionalAmount 已经包含了完整的材质价格，不需要再加基础价格
            const isAlchemyRing = document.querySelector('.alchemy-material-option') !== null;
            if (isAlchemyRing) {
                includeBasePrice = false;
                console.log('检测到炼金戒指产品，使用 includeBasePrice=false');
            }

            // 获取存储的价格信息
            const basePrice = parseFloat(priceElement.getAttribute('data-base-price'));
            const originalFull = priceElement.getAttribute('data-original-full');
            const thousandSep = priceElement.getAttribute('data-thousand-sep');
            const decimalSep = priceElement.getAttribute('data-decimal-sep');
            const originalDecimalPart = priceElement.getAttribute('data-original-decimal');
            const pricePattern = priceElement.getAttribute('data-price-pattern');
            // 计算新价格
            const newPriceVal = includeBasePrice ? (basePrice + additionalAmount) : additionalAmount;
             // 确定用于格式化的小数部分
            let decimalPartForFormat = priceElement.getAttribute('data-original-decimal');
            if (!includeBasePrice) {
                // 直接使用新价格的小数部分（两位），如 127 -> 00，127.5 -> 50
                decimalPartForFormat = (newPriceVal % 1).toFixed(2).split('.')[1];
            }
            console.log('原始价格数值:', basePrice, '附加金额:', additionalAmount, '新价格数值:', newPriceVal);

            // 格式化新价格
            const newPriceFormatted = PriceUpdater.formatNumberWithSeparators(
                newPriceVal,
                thousandSep,
                decimalSep,
                decimalPartForFormat
            );
            console.log('格式化后的新价格:', newPriceFormatted);

            // 替换原始价格中的数字部分并更新显示
            const newPriceStr = originalFull.replace(pricePattern, newPriceFormatted);
            priceElement.textContent = newPriceStr;

            PriceUpdater.updatePromotionPrice(
                priceElement,
                newPriceVal,
                thousandSep,
                decimalSep,
                pricePattern,
                originalFull
            );

            return newPriceVal;
        }
    }

    // 存储各类型加价
    let ringSizeSurcharge = 0;
    let inscriptionSurcharge = 0;
    let engravingGroups = 0;
    let birthstonesGroups = 0;
    let letterStoneGroups = 0;
    let kGold = 0;
    let multipleOption = 0
    let moissanitePriceTotal = 0
    let alchemyMaterialPriceTotal = 0

    function updatePriceWithSurcharge() {
        console.log('updatePriceWithSurcharge');
        const ringSizeSelect = document.getElementById('ring-size');
        let priceElement;
        let oldPriceElement;
        let discountElement = document.querySelector('.save-off');
        let fairPriceElement = document.querySelector('.fair-price-hide');
        const saleRegularPrice = document.querySelector('.price__sale s.price-item--regular').innerHTML.trim() === '';
        if (saleRegularPrice) {
            priceElement = document.querySelector('.price__regular .price-item--regular');
        } else {
            priceElement = document.querySelector('.price__sale .price-item--last');
            oldPriceElement = document.querySelector('.price__sale s.price-item--regular');
        }

        if (!ringSizeSelect || !priceElement) return;

        // 获取附加费用（转换为元）
        const selectedOption = ringSizeSelect.options[ringSizeSelect.selectedIndex];
        const surchargeCents = parseFloat(selectedOption.getAttribute('data-surcharge') || 0);
        const surcharge = surchargeCents / 100; // 将分转换为元
        ringSizeSurcharge = surcharge
        //计算总加价
        const totalSurcharge = ringSizeSurcharge + inscriptionSurcharge + engravingGroups + birthstonesGroups + letterStoneGroups + kGold + multipleOption + alchemyMaterialPriceTotal + moissanitePriceTotal;
        // 调用通用方法更新价格
        const updatedPrice = PriceUpdater.updatePrice(priceElement, totalSurcharge, true);
        if (oldPriceElement) {
            // 获取基础价格（从原始价格元素获取，而不是计算）
            const basePrice = parseFloat(priceElement.getAttribute('data-base-price'));
            // 获取原始原价
            const originalOldPrice = parseFloat(oldPriceElement.getAttribute('data-base-price')) ||
                Math.ceil(basePrice / 0.6 * 100) / 100; // 保留2位小数

            // 如果有加价，则计算新的原价，否则使用原始原价
            const newOldPrice = (totalSurcharge > 0) ?
                Math.ceil(updatedPrice / 0.6 * 100) / 100 :  // 保留2位小数
                originalOldPrice;

            PriceUpdater.updatePrice(oldPriceElement, newOldPrice, false);
            // 更新折扣价格（原价 - 现价）
            if (discountElement) {
                const discountAmount = newOldPrice - updatedPrice;
                PriceUpdater.updatePrice(discountElement, discountAmount, false);
            }
        }

        // Update fair price (2.8 times the current price)
        if (fairPriceElement) {
            const currentPrice = updatedPrice || parseFloat(priceElement.getAttribute('data-base-price') || 0);
            const fairPrice = Math.round(currentPrice * 2.8 * 100) / 100; // Round to 2 decimal places
            console.log('Updating fair price:', { currentPrice, fairPrice });
            PriceUpdater.updatePrice(fairPriceElement, fairPrice, false);
        }
    }

    // Function to update price based on selected inscription groups
    function updatePriceForInscriptionGroups() {
        console.log('updatePriceForInscriptionGroups');
        const inscriptionSelect = document.getElementById('inscription-count');
        let priceElement;
        let oldPriceElement;
        let discountElement = document.querySelector('.save-off');
        let fairPriceElement = document.querySelector('.fair-price-hide');
        const saleRegularPrice = document.querySelector('.price__sale s.price-item--regular').innerHTML.trim() === '';
        if (saleRegularPrice) {
            priceElement = document.querySelector('.price__regular .price-item--regular');
        } else {
            priceElement = document.querySelector('.price__sale .price-item--last');
            oldPriceElement = document.querySelector('.price__sale s.price-item--regular');
        }
        if (!inscriptionSelect || !priceElement) return;

        // 获取附加费用（转换为元）
        const selectedOption = inscriptionSelect.options[inscriptionSelect.selectedIndex];
        const additionalCents = parseFloat(selectedOption?.getAttribute('data-price') || 0);
        const additionalAmount = additionalCents / 100;
        inscriptionSurcharge = additionalAmount
        const totalSurcharge = ringSizeSurcharge + inscriptionSurcharge + engravingGroups + birthstonesGroups + letterStoneGroups + kGold + multipleOption + alchemyMaterialPriceTotal + moissanitePriceTotal;
        // 调用通用方法更新价格
        const updatedPrice = PriceUpdater.updatePrice(priceElement, totalSurcharge, true);
        if (oldPriceElement) {
            // 获取基础价格（从原始价格元素获取，而不是计算）
            const basePrice = parseFloat(priceElement.getAttribute('data-base-price'));
            // 获取原始原价
            const originalOldPrice = parseFloat(oldPriceElement.getAttribute('data-base-price')) ||
                Math.ceil(basePrice / 0.6 * 100) / 100; // 保留2位小数

            // 如果有加价，则计算新的原价，否则使用原始原价
            const newOldPrice = (totalSurcharge > 0) ?
                Math.ceil(updatedPrice / 0.6 * 100) / 100 :  // 保留2位小数
                originalOldPrice;

            PriceUpdater.updatePrice(oldPriceElement, newOldPrice, false);
            // 更新折扣价格（原价 - 现价）
            if (discountElement) {
                const discountAmount = newOldPrice - updatedPrice;
                PriceUpdater.updatePrice(discountElement, discountAmount, false);
            }
        }
        // Update fair price (2.8 times the current price)
        if (fairPriceElement) {
            const currentPrice = updatedPrice || parseFloat(priceElement.getAttribute('data-base-price') || 0);
            const fairPrice = Math.round(currentPrice * 2.8 * 100) / 100; // Round to 2 decimal places
            console.log('Updating fair price:', { currentPrice, fairPrice });
            PriceUpdater.updatePrice(fairPriceElement, fairPrice, false);
        }
    }

    function updatePriceForEngravingGroups() {
        console.log('updatePriceForEngravingGroups');
        const engravingSelect = document.getElementById('engraving-count');
        let priceElement;
        let oldPriceElement;
        let discountElement = document.querySelector('.save-off');
        let fairPriceElement = document.querySelector('.fair-price-hide');
        const saleRegularPrice = document.querySelector('.price__sale s.price-item--regular').innerHTML.trim() === '';
        if (saleRegularPrice) {
            priceElement = document.querySelector('.price__regular .price-item--regular');
        } else {
            priceElement = document.querySelector('.price__sale .price-item--last');
            oldPriceElement = document.querySelector('.price__sale s.price-item--regular');
        }
        if (!engravingSelect || !priceElement) return;
        // 获取附加费用（转换为元）
        const selectedOption = engravingSelect.options[engravingSelect.selectedIndex];
        const additionalCents = parseFloat(selectedOption?.getAttribute('data-price') || 0);
        const additionalAmount = additionalCents / 100;
        engravingGroups = additionalAmount
        const totalSurcharge = ringSizeSurcharge + inscriptionSurcharge + engravingGroups + birthstonesGroups + letterStoneGroups + kGold + multipleOption + alchemyMaterialPriceTotal + moissanitePriceTotal;
        // 调用通用方法更新价格
        const updatedPrice = PriceUpdater.updatePrice(priceElement, totalSurcharge, true);
        if (oldPriceElement) {
            // 获取基础价格（从原始价格元素获取，而不是计算）
            const basePrice = parseFloat(priceElement.getAttribute('data-base-price'));
            // 获取原始原价
            const originalOldPrice = parseFloat(oldPriceElement.getAttribute('data-base-price')) ||
                Math.ceil(basePrice / 0.6 * 100) / 100; // 保留2位小数

            // 如果有加价，则计算新的原价，否则使用原始原价
            const newOldPrice = (totalSurcharge > 0) ?
                Math.ceil(updatedPrice / 0.6 * 100) / 100 :  // 保留2位小数
                originalOldPrice;

            PriceUpdater.updatePrice(oldPriceElement, newOldPrice, false);
            // 更新折扣价格（原价 - 现价）
            if (discountElement) {
                const discountAmount = newOldPrice - updatedPrice;
                PriceUpdater.updatePrice(discountElement, discountAmount, false);
            }
        }
        // Update fair price (2.8 times the current price)
        if (fairPriceElement) {
            const currentPrice = updatedPrice || parseFloat(priceElement.getAttribute('data-base-price') || 0);
            const fairPrice = Math.round(currentPrice * 2.8 * 100) / 100; // Round to 2 decimal places
            console.log('Updating fair price:', { currentPrice, fairPrice });
            PriceUpdater.updatePrice(fairPriceElement, fairPrice, false);
        }
    }

    function updatePriceForBirthstonesGroups() {
        console.log('updatePriceForBirthstonesGroups');
        const stoneSelect = document.getElementById('birthstones-count');
        let priceElement;
        let oldPriceElement;
        let discountElement = document.querySelector('.save-off');
        let fairPriceElement = document.querySelector('.fair-price-hide');
        const saleRegularPrice = document.querySelector('.price__sale s.price-item--regular').innerHTML.trim() === '';
        if (saleRegularPrice) {
            priceElement = document.querySelector('.price__regular .price-item--regular');
        } else {
            priceElement = document.querySelector('.price__sale .price-item--last');
            oldPriceElement = document.querySelector('.price__sale s.price-item--regular');
        }
        if (!stoneSelect || !priceElement) return;

        // 获取附加费用（转换为元）
        const selectedOption = stoneSelect.options[stoneSelect.selectedIndex];
        const additionalCents = parseFloat(selectedOption?.getAttribute('data-price') || 0);
        const additionalAmount = additionalCents / 100;
        birthstonesGroups = additionalAmount
        const totalSurcharge = ringSizeSurcharge + inscriptionSurcharge + engravingGroups + birthstonesGroups + letterStoneGroups + kGold + multipleOption + alchemyMaterialPriceTotal + moissanitePriceTotal;
        // 调用通用方法更新价格
        const updatedPrice = PriceUpdater.updatePrice(priceElement, totalSurcharge, true);
        if (oldPriceElement) {
            // 获取基础价格（从原始价格元素获取，而不是计算）
            const basePrice = parseFloat(priceElement.getAttribute('data-base-price'));
            // 获取原始原价
            const originalOldPrice = parseFloat(oldPriceElement.getAttribute('data-base-price')) ||
                Math.ceil(basePrice / 0.6 * 100) / 100; // 保留2位小数

            // 如果有加价，则计算新的原价，否则使用原始原价
            const newOldPrice = (totalSurcharge > 0) ?
                Math.ceil(updatedPrice / 0.6 * 100) / 100 :  // 保留2位小数
                originalOldPrice;

            PriceUpdater.updatePrice(oldPriceElement, newOldPrice, false);
            // 更新折扣价格（原价 - 现价）
            if (discountElement) {
                const discountAmount = newOldPrice - updatedPrice;
                PriceUpdater.updatePrice(discountElement, discountAmount, false);
            }
        }
        // Update fair price (2.8 times the current price)
        if (fairPriceElement) {
            const currentPrice = updatedPrice || parseFloat(priceElement.getAttribute('data-base-price') || 0);
            const fairPrice = Math.round(currentPrice * 2.8 * 100) / 100; // Round to 2 decimal places
            console.log('Updating fair price:', { currentPrice, fairPrice });
            PriceUpdater.updatePrice(fairPriceElement, fairPrice, false);
        }
    }

    function updatePriceForLetterStoneGroups() {
        console.log('updatePriceForLetterStoneGroups');
        const inscriptionSelect = document.getElementById('birthstone-letter-count');
        let priceElement;
        let oldPriceElement;
        let discountElement = document.querySelector('.save-off');
        let fairPriceElement = document.querySelector('.fair-price-hide');
        const saleRegularPrice = document.querySelector('.price__sale s.price-item--regular').innerHTML.trim() === '';
        if (saleRegularPrice) {
            priceElement = document.querySelector('.price__regular .price-item--regular');
        } else {
            priceElement = document.querySelector('.price__sale .price-item--last');
            oldPriceElement = document.querySelector('.price__sale s.price-item--regular');
        }
        if (!inscriptionSelect || !priceElement) return;

        // 获取附加费用（转换为元）
        const selectedOption = inscriptionSelect.options[inscriptionSelect.selectedIndex];
        const additionalCents = parseFloat(selectedOption?.getAttribute('data-price') || 0);
        const additionalAmount = additionalCents / 100;
        letterStoneGroups = additionalAmount
        const totalSurcharge = ringSizeSurcharge + inscriptionSurcharge + engravingGroups + birthstonesGroups + letterStoneGroups + kGold + multipleOption + alchemyMaterialPriceTotal + moissanitePriceTotal;
        // 调用通用方法更新价格
        const updatedPrice = PriceUpdater.updatePrice(priceElement, totalSurcharge, true);
        if (oldPriceElement) {
            // 获取基础价格（从原始价格元素获取，而不是计算）
            const basePrice = parseFloat(priceElement.getAttribute('data-base-price'));
            // 获取原始原价
            const originalOldPrice = parseFloat(oldPriceElement.getAttribute('data-base-price')) ||
                Math.ceil(basePrice / 0.6 * 100) / 100; // 保留2位小数

            // 如果有加价，则计算新的原价，否则使用原始原价
            const newOldPrice = (totalSurcharge > 0) ?
                Math.ceil(updatedPrice / 0.6 * 100) / 100 :  // 保留2位小数
                originalOldPrice;

            PriceUpdater.updatePrice(oldPriceElement, newOldPrice, false);
            // 更新折扣价格（原价 - 现价）
            if (discountElement) {
                const discountAmount = newOldPrice - updatedPrice;
                PriceUpdater.updatePrice(discountElement, discountAmount, false);
            }
        }
        // Update fair price (2.8 times the current price)
        if (fairPriceElement) {
            const currentPrice = updatedPrice || parseFloat(priceElement.getAttribute('data-base-price') || 0);
            const fairPrice = Math.round(currentPrice * 2.8 * 100) / 100; // Round to 2 decimal places
            console.log('Updating fair price:', { currentPrice, fairPrice });
            PriceUpdater.updatePrice(fairPriceElement, fairPrice, false);
        }
    }

    function updatePriceForKGold() {
        console.log('updatePriceForKGold');

        // Get the price element based on whether the product is on sale
        let priceElement;
        let oldPriceElement;
        let discountElement = document.querySelector('.save-off');
        let fairPriceElement = document.querySelector('.fair-price-hide');
        const saleRegularPrice = document.querySelector('.price__sale s.price-item--regular');
        if (saleRegularPrice && saleRegularPrice.innerHTML.trim() === '') {
            priceElement = document.querySelector('.price__regular .price-item--regular');
        } else {
            priceElement = document.querySelector('.price__sale .price-item--last') ||
                document.querySelector('.price__regular .price-item--regular');
            oldPriceElement = document.querySelector('.price__sale s.price-item--regular');
        }

        if (!priceElement) {
            console.warn('Price element not found');
            return;
        }
        // debugger;

        // Get selected material and stone prices
        const selectedMaterial = document.querySelector('.material-option.selected');
        const selectedStone = document.querySelector('.stone-image.selected');

        let materialPrice = 0;
        let stonePrice = 0;

        // Extract material price if selected
        if (selectedMaterial) {
            const materialPriceEl = selectedMaterial.querySelector('.option-price');
            if (materialPriceEl) {
                materialPrice = parseFloat(materialPriceEl.getAttribute('data-price') || 0) / 100;
            }
        }

        // Extract stone price if selected
        if (selectedStone) {
            const stonePriceEl = selectedStone.querySelector('.option-price');
            if (stonePriceEl) {
                stonePrice = parseFloat(stonePriceEl.getAttribute('data-price') || 0) / 100;
            }
        }

        // Calculate total additional amount
        kGold = materialPrice + stonePrice;
        console.log('kGold', kGold);
        const totalSurcharge = ringSizeSurcharge + inscriptionSurcharge + engravingGroups + birthstonesGroups + letterStoneGroups + kGold + multipleOption + alchemyMaterialPriceTotal + moissanitePriceTotal;
        // Update the price display
        const updatedPrice = PriceUpdater.updatePrice(priceElement, totalSurcharge, true);
        if (oldPriceElement) {
            // 获取基础价格（从原始价格元素获取，而不是计算）
            const basePrice = parseFloat(priceElement.getAttribute('data-base-price'));
            // 获取原始原价
            const originalOldPrice = parseFloat(oldPriceElement.getAttribute('data-base-price')) ||
                Math.ceil(basePrice / 0.6 * 100) / 100; // 保留2位小数

            // 如果有加价，则计算新的原价，否则使用原始原价
            const newOldPrice = (totalSurcharge > 0) ?
                Math.ceil(updatedPrice / 0.6 * 100) / 100 :  // 保留2位小数
                originalOldPrice;

            PriceUpdater.updatePrice(oldPriceElement, newOldPrice, false);
            if (discountElement) {
                const discountAmount = newOldPrice - updatedPrice;
                PriceUpdater.updatePrice(discountElement, discountAmount, false);
            }
        }
        // Update fair price (2.8 times the current price)
        if (fairPriceElement) {
            const currentPrice = updatedPrice || parseFloat(priceElement.getAttribute('data-base-price') || 0);
            const fairPrice = Math.round(currentPrice * 2.8 * 100) / 100; // Round to 2 decimal places
            console.log('Updating fair price:', { currentPrice, fairPrice });
            PriceUpdater.updatePrice(fairPriceElement, fairPrice, false);
        }

    }

    function updatePriceForEarringsSize() {
        console.log('updatePriceForEarringsSize');
        const earringsSizeSelect = document.getElementById('earrings-size');
        let priceElement;
        let oldPriceElement;
        let discountElement = document.querySelector('.save-off');
        let fairPriceElement = document.querySelector('.fair-price-hide');
        const saleRegularPrice = document.querySelector('.price__sale s.price-item--regular').innerHTML.trim() === '';
        if (saleRegularPrice) {
            priceElement = document.querySelector('.price__regular .price-item--regular');
        } else {
            priceElement = document.querySelector('.price__sale .price-item--last');
            oldPriceElement = document.querySelector('.price__sale s.price-item--regular');
        }

        if (!earringsSizeSelect || !priceElement) return;

        // 获取附加费用（转换为元）
        const selectedOption = earringsSizeSelect.options[earringsSizeSelect.selectedIndex];
        const surchargeCents = parseFloat(selectedOption.getAttribute('data-surcharge') || 0);
        const surcharge = surchargeCents / 100; // 将分转换为元
        earringsSizeSurcharge = surcharge
        //计算总加价
        const totalSurcharge = earringsSizeSurcharge + inscriptionSurcharge + engravingGroups + birthstonesGroups + letterStoneGroups + kGold + ringSizeSurcharge + alchemyMaterialPriceTotal + moissanitePriceTotal;
        // 调用通用方法更新价格
        const updatedPrice = PriceUpdater.updatePrice(priceElement, totalSurcharge, true);
        if (oldPriceElement) {
            // 获取基础价格（从原始价格元素获取，而不是计算）
            const basePrice = parseFloat(priceElement.getAttribute('data-base-price'));
            // 获取原始原价
            const originalOldPrice = parseFloat(oldPriceElement.getAttribute('data-base-price')) ||
                Math.ceil(basePrice / 0.6 * 100) / 100; // 保留2位小数

            // 如果有加价，则计算新的原价，否则使用原始原价
            const newOldPrice = (totalSurcharge > 0) ?
                Math.ceil(updatedPrice / 0.6 * 100) / 100 :  // 保留2位小数
                originalOldPrice;

            PriceUpdater.updatePrice(oldPriceElement, newOldPrice, false);
            // 更新折扣价格（原价 - 现价）
            if (discountElement) {
                const discountAmount = newOldPrice - updatedPrice;
                PriceUpdater.updatePrice(discountElement, discountAmount, false);
            }
        }

        // Update fair price (2.8 times the current price)
        if (fairPriceElement) {
            const currentPrice = updatedPrice || parseFloat(priceElement.getAttribute('data-base-price') || 0);
            const fairPrice = Math.round(currentPrice * 2.8 * 100) / 100; // Round to 2 decimal places
            console.log('Updating fair price:', { currentPrice, fairPrice });
            PriceUpdater.updatePrice(fairPriceElement, fairPrice, false);
        }
    }

    function updatePriceForMultipleOptions() {
        console.log('updatePriceForMultipleOptions');

        // Get the price element based on whether the product is on sale
        let priceElement;
        let oldPriceElement;
        let discountElement = document.querySelector('.save-off');
        let fairPriceElement = document.querySelector('.fair-price-hide');
        const saleRegularPrice = document.querySelector('.price__sale s.price-item--regular');
        if (saleRegularPrice && saleRegularPrice.innerHTML.trim() === '') {
            priceElement = document.querySelector('.price__regular .price-item--regular');
        } else {
            priceElement = document.querySelector('.price__sale .price-item--last') ||
                document.querySelector('.price__regular .price-item--regular');
            oldPriceElement = document.querySelector('.price__sale s.price-item--regular');
        }

        if (!priceElement) {
            console.warn('Price element not found');
            return;
        }
        // debugger;

        // Sum surcharge of every selected option across all multiple-option groups
        let multiPriceTotal = 0;
        document.querySelectorAll('.multiple-options.selected').forEach(item => {
            const priceEl = item.querySelector('.option-price');
            if (priceEl) {
                multiPriceTotal += parseFloat(priceEl.getAttribute('data-price') || 0) / 100;
            }
        });

        multipleOption = multiPriceTotal
        const totalSurcharge = ringSizeSurcharge + inscriptionSurcharge + engravingGroups + birthstonesGroups + letterStoneGroups + kGold + multipleOption + alchemyMaterialPriceTotal + moissanitePriceTotal;
        // Update the price display
        const updatedPrice = PriceUpdater.updatePrice(priceElement, totalSurcharge, true);
        if (oldPriceElement) {
            // 获取基础价格（从原始价格元素获取，而不是计算）
            const basePrice = parseFloat(priceElement.getAttribute('data-base-price'));
            // 获取原始原价
            const originalOldPrice = parseFloat(oldPriceElement.getAttribute('data-base-price')) ||
                Math.ceil(basePrice / 0.6 * 100) / 100; // 保留2位小数

            // 如果有加价，则计算新的原价，否则使用原始原价
            const newOldPrice = (totalSurcharge > 0) ?
                Math.ceil(updatedPrice / 0.6 * 100) / 100 :  // 保留2位小数
                originalOldPrice;

            PriceUpdater.updatePrice(oldPriceElement, newOldPrice, false);
            if (discountElement) {
                const discountAmount = newOldPrice - updatedPrice;
                PriceUpdater.updatePrice(discountElement, discountAmount, false);
            }
        }
        // Update fair price (2.8 times the current price)
        if (fairPriceElement) {
            const currentPrice = updatedPrice || parseFloat(priceElement.getAttribute('data-base-price') || 0);
            const fairPrice = Math.round(currentPrice * 2.8 * 100) / 100; // Round to 2 decimal places
            console.log('Updating fair price:', { currentPrice, fairPrice });
            PriceUpdater.updatePrice(fairPriceElement, fairPrice, false);
        }

    }



    function updatePriceForAlchemyMaterial() {
        console.log('updatePriceForAlchemyMaterial');

        // Get the price element based on whether the product is on sale
        let priceElement;
        let oldPriceElement;
        let discountElement = document.querySelector('.save-off');
        let fairPriceElement = document.querySelector('.fair-price-hide');
        const saleRegularPrice = document.querySelector('.price__sale s.price-item--regular');
        if (saleRegularPrice && saleRegularPrice.innerHTML.trim() === '') {
            priceElement = document.querySelector('.price__regular .price-item--regular');
        } else {
            priceElement = document.querySelector('.price__sale .price-item--last') ||
                document.querySelector('.price__regular .price-item--regular');
            oldPriceElement = document.querySelector('.price__sale s.price-item--regular');
        }

        if (!priceElement) {
            console.warn('Price element not found');
            return;
        }
        // debugger;

        // Sum surcharge of every selected option across all multiple-option groups
        let alchemyMaterialPrice = 0;
        const alchemyMaterialOption = document.querySelector('.alchemy-material-option.selected');

        if (alchemyMaterialOption) {
            const materialPriceEl = alchemyMaterialOption.querySelector('.option-price');
            if (materialPriceEl) {
                const priceAttr = materialPriceEl.getAttribute('data-price');
                console.log('Material data-price attribute:', priceAttr);
                alchemyMaterialPrice = parseFloat(priceAttr || 0) / 100;
                console.log('Material price total:', alchemyMaterialPrice);
            }
        }

        alchemyMaterialPriceTotal = alchemyMaterialPrice;
        const totalSurcharge = ringSizeSurcharge + inscriptionSurcharge + engravingGroups + birthstonesGroups + letterStoneGroups + kGold + multipleOption + alchemyMaterialPriceTotal + moissanitePriceTotal;
        // Update the price display - 设置 includeBasePrice=false，直接使用 totalSurcharge 作为最终价格
        const updatedPrice = PriceUpdater.updatePrice(priceElement, totalSurcharge, false);

        if (oldPriceElement) {
            // 获取基础价格（从原始价格元素获取，而不是计算）
            const basePrice = parseFloat(priceElement.getAttribute('data-base-price'));
            // 获取原始原价
            const originalOldPrice = parseFloat(oldPriceElement.getAttribute('data-base-price')) ||
                Math.ceil(basePrice / 0.6 * 100) / 100; // 保留2位小数

            // 如果有加价，则计算新的原价，否则使用原始原价
            const newOldPrice = (totalSurcharge > 0) ?
                Math.ceil(updatedPrice / 0.6 * 100) / 100 :  // 保留2位小数
                originalOldPrice;

            PriceUpdater.updatePrice(oldPriceElement, newOldPrice, false);
            if (discountElement) {
                const discountAmount = newOldPrice - updatedPrice;
                PriceUpdater.updatePrice(discountElement, discountAmount, false);
            }
        }
        // Update fair price (2.8 times the current price)
        if (fairPriceElement) {
            const currentPrice = updatedPrice || parseFloat(priceElement.getAttribute('data-base-price') || 0);
            const fairPrice = Math.round(currentPrice * 2.8 * 100) / 100; // Round to 2 decimal places
            console.log('Updating fair price:', { currentPrice, fairPrice });
            PriceUpdater.updatePrice(fairPriceElement, fairPrice, false);
        }

    }




    function updatePriceForMoissanite() {
        console.log('updatePriceForMoissanite');

        // Get the price element based on whether the product is on sale
        let priceElement;
        let oldPriceElement;
        let discountElement = document.querySelector('.save-off');
        let fairPriceElement = document.querySelector('.fair-price-hide');
        const saleRegularPrice = document.querySelector('.price__sale s.price-item--regular');
        if (saleRegularPrice && saleRegularPrice.innerHTML.trim() === '') {
            priceElement = document.querySelector('.price__regular .price-item--regular');
        } else {
            priceElement = document.querySelector('.price__sale .price-item--last') ||
                document.querySelector('.price__regular .price-item--regular');
            oldPriceElement = document.querySelector('.price__sale s.price-item--regular');
        }

        if (!priceElement) {
            console.warn('Price element not found');
            return;
        }
        let moissanitePrice = 0;
        const moissaniteOption = document.querySelector('.moissanite-stone-option.selected');

        if (moissaniteOption) {
            const materialPriceEl = moissaniteOption.querySelector('.option-price');
            if (materialPriceEl) {
                const priceAttr = materialPriceEl.getAttribute('data-price');
                console.log('Material data-price attribute:', priceAttr);
                moissanitePrice = parseFloat(priceAttr || 0) / 100;
                console.log('Material price total:', moissanitePrice);
            }
        }



        moissanitePriceTotal = moissanitePrice;
        const totalSurcharge = ringSizeSurcharge + inscriptionSurcharge + engravingGroups + birthstonesGroups + letterStoneGroups + kGold + multipleOption + alchemyMaterialPriceTotal + moissanitePriceTotal;
        // Update the price display - 设置 includeBasePrice=false，直接使用 totalSurcharge 作为最终价格
        const updatedPrice = PriceUpdater.updatePrice(priceElement, totalSurcharge, false);

        if (oldPriceElement) {
            // 获取基础价格（从原始价格元素获取，而不是计算）
            const basePrice = parseFloat(priceElement.getAttribute('data-base-price'));
            // 获取原始原价
            const originalOldPrice = parseFloat(oldPriceElement.getAttribute('data-base-price')) ||
                Math.ceil(basePrice / 0.6 * 100) / 100; // 保留2位小数

            // 如果有加价，则计算新的原价，否则使用原始原价
            const newOldPrice = (totalSurcharge > 0) ?
                Math.ceil(updatedPrice / 0.6 * 100) / 100 :  // 保留2位小数
                originalOldPrice;

            PriceUpdater.updatePrice(oldPriceElement, newOldPrice, false);
            if (discountElement) {
                const discountAmount = newOldPrice - updatedPrice;
                PriceUpdater.updatePrice(discountElement, discountAmount, false);
            }
        }
        // Update fair price (2.8 times the current price)
        if (fairPriceElement) {
            const currentPrice = updatedPrice || parseFloat(priceElement.getAttribute('data-base-price') || 0);
            const fairPrice = Math.round(currentPrice * 2.8 * 100) / 100; // Round to 2 decimal places
            console.log('Updating fair price:', { currentPrice, fairPrice });
            PriceUpdater.updatePrice(fairPriceElement, fairPrice, false);
        }

    }

    document.querySelectorAll('.moissanite-stone-option').forEach(option => {
        console.log('moissanite-stone-option');
        option.addEventListener('click', function () {
            // Wait a small amount of time to ensure the 'selected' class is updated
            setTimeout(updatePriceForMoissanite, 10);
        });
    });

    document.querySelectorAll('.alchemy-material-option').forEach(option => {
        console.log('alchemy-material-option');
        option.addEventListener('click', function () {
            // Wait a small amount of time to ensure the 'selected' class is updated
            setTimeout(updatePriceForAlchemyMaterial, 10);
        });
    });

    // Update price when ring size changes
    const ringSizeSelect = document.getElementById('ring-size');
    if (ringSizeSelect) {
        ringSizeSelect.addEventListener('change', updatePriceWithSurcharge);

        // Initial update in case a size is pre-selected
        if (ringSizeSelect.value) {
            updatePriceWithSurcharge();
        }
    }

    // Update price when earrings size changes
    const earringsSizeSelect = document.getElementById('earrings-size');
    if (earringsSizeSelect) {
        earringsSizeSelect.addEventListener('change', updatePriceForEarringsSize);

        // Initial update in case a size is pre-selected
        if (earringsSizeSelect.value) {
            updatePriceForEarringsSize();
        }
    }

    // Update price when engraving count changes
    const engravingSelect = document.getElementById('engraving-count');
    if (engravingSelect) {
        engravingSelect.addEventListener('change', function () {
            updatePriceForEngravingGroups();

            // If there's also a ring size selected, update that price as well
            const ringSizeSelect = document.getElementById('ring-size');
            if (ringSizeSelect && ringSizeSelect.value) {
                updatePriceWithSurcharge();
            }
        });

        // Initial update in case a count is pre-selected
        if (engravingSelect.value) {
            updatePriceForEngravingGroups();
        }
    }

    // Update price when birthstones count changes
    const birthstonesSelect = document.getElementById('birthstones-count');
    if (birthstonesSelect) {
        birthstonesSelect.addEventListener('change', function () {
            updatePriceForBirthstonesGroups();

            // If there's also a ring size selected, update that price as well
            const ringSizeSelect = document.getElementById('ring-size');
            if (ringSizeSelect && ringSizeSelect.value) {
                updatePriceWithSurcharge();
            }
        });

        // Initial update in case a count is pre-selected
        if (birthstonesSelect.value) {
            updatePriceForBirthstonesGroups();
        }
    }

    // Update price when inscription count changes
    const inscriptionSelect = document.getElementById('inscription-count');
    if (inscriptionSelect) {
        inscriptionSelect.addEventListener('change', function () {
            // First update the inscription price
            updatePriceForInscriptionGroups();

            // If there's also a ring size selected, update that price as well
            if (ringSizeSelect && ringSizeSelect.value) {
                updatePriceWithSurcharge();
            }
        });

        // Initial update in case a count is pre-selected
        if (inscriptionSelect.value) {
            updatePriceForInscriptionGroups();
        }
    }

    // Update price when inscription count changes
    const letterStoneSelect = document.getElementById('birthstone-letter-count');
    if (letterStoneSelect) {
        letterStoneSelect.addEventListener('change', function () {
            // First update the inscription price
            updatePriceForLetterStoneGroups();

            // If there's also a ring size selected, update that price as well
            if (ringSizeSelect && ringSizeSelect.value) {
                updatePriceWithSurcharge();
            }
        });

        // Initial update in case a count is pre-selected
        if (letterStoneSelect.value) {
            updatePriceForLetterStoneGroups();
        }
    }

    // Update price when K-Gold material or stone selection changes
    document.querySelectorAll('.material-option, .stone-image, .birthstone-option').forEach(option => {
        option.addEventListener('click', function () {
            // Wait a small amount of time to ensure the 'selected' class is updated
            setTimeout(updatePriceForKGold, 10);
        });
    });

    document.querySelectorAll('.multiple-options').forEach(option => {
        option.addEventListener('click', function () {
            // Wait a small amount of time to ensure the 'selected' class is updated
            setTimeout(updatePriceForMultipleOptions, 10);
        });
    });

    // 初次进入页面时，如已有默认选中项，立即计算多选项加价
    if (document.querySelector('.multiple-options.selected')) {
        setTimeout(updatePriceForMultipleOptions, 50);
    }

    // Initial update for K-Gold if there are any selected options
    if (document.querySelector('.material-option.selected') ||
        document.querySelector('.stone-image.selected')) {
        setTimeout(updatePriceForKGold, 100);
    }

    // --- Color Selection Functionality ---
    document.querySelectorAll('.color-option').forEach(option => {
        option.addEventListener('click', function () {
            const container = this.closest('.color-options-container');
            if (!container) return;

            // Remove active class from all options in the same group
            container.querySelectorAll('.color-option').forEach(opt => {
                opt.classList.remove('active');
            });

            // Add active class to clicked option
            this.classList.add('active');

            // Update the hidden input value
            const value = this.getAttribute('data-value');
            const hiddenInput = container.querySelector('input[type="hidden"]');
            if (hiddenInput) {
                hiddenInput.value = value;
            }
        });
    });

    // Initialize first option as active if none is selected
    document.querySelectorAll('.color-options-container').forEach(container => {
        const hasActive = container.querySelector('.color-option.active');
        if (!hasActive) {
            const firstOption = container.querySelector('.color-option');
            if (firstOption) {
                firstOption.classList.add('active');
                const value = firstOption.getAttribute('data-value');
                const hiddenInput = container.querySelector('input[type="hidden"]');
                if (hiddenInput) {
                    hiddenInput.value = value;
                }
            }
        }
    });

    // --- Start of original functionalities ---
    if (typeof MicroModal !== 'undefined') {
        MicroModal.init();
    }



    document.querySelectorAll('[name="add"]').forEach(button => {
        button.addEventListener('click', e => {
            const imageInput = document.getElementById('image_preview_1');
            if (imageInput && !imageInput.value) {
                e.preventDefault();
                if (typeof MicroModal !== 'undefined') {
                    MicroModal.show('modal-1', {
                        awaitCloseAnimation: true,
                        onShow: modal => document.querySelectorAll(".product__info-wrapper.scroll-trigger").forEach(el => el.classList.remove("scroll-trigger")),
                    });
                }
            }
        });
    });


    async function generateSignature(timestamp) {
        const parts = [
            '3639', '3a23', '3027', '3137', '3734', '6136', '6266', '3065', '6337', '3166', '3661', '3062', '3164',
            '6d61', '6334', '6362', '3362', '6164', '3760', '6d67', '3363', '6564', '3363', '626d', '6165', '3736',
            '3360', '3067', '6234', '6430', '6230', '6431', '67',
        ];

        const decodeHex = hex => {
            let result = '';
            for (let i = 0; i < hex.length; i += 2)
                result += String.fromCharCode(parseInt(hex.substring(i, i + 2), 16));
            return result;
        };

        const xorDecode = (str, key) =>
            Array.from(str, ch => String.fromCharCode(ch.charCodeAt(0) ^ key)).join('');

        const encoder = new TextEncoder();
        const keyData = encoder.encode(xorDecode(parts.map(decodeHex).join(''), 0x55));
        const msgData = encoder.encode(String(timestamp));

        const cryptoKey = await crypto.subtle.importKey(
            'raw', keyData, { name: 'HMAC', hash: 'SHA-256' }, false, ['sign']
        );

        const signatureBuffer = await crypto.subtle.sign('HMAC', cryptoKey, msgData);
        return Array.from(new Uint8Array(signatureBuffer))
            .map(b => b.toString(16).padStart(2, '0'))
            .join('');
    }


    window.uploadDesignBase64 = async function (base64Data) {

        const timestamp = Date.now();
        const signature = await generateSignature(timestamp);

        const response = await fetch('https://tthrtbqo1i.execute-api.us-east-1.amazonaws.com/default/uploadCustomImage', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ timestamp, signature, imageBase64: base64Data }),
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Upload Error');
        }

        const data = await response.json();
        return data.imageUrl;
    }

    window.uploadDesignImageFile = async function (file) {

        const timestamp = Date.now();
        const signature = await generateSignature(timestamp);

        const res = await fetch('https://tthrtbqo1i.execute-api.us-east-1.amazonaws.com/default/uploadS3Image', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ timestamp, signature }),
        });

        if (!res.ok) {
            const error = await res.json().catch(() => ({}));
            throw new Error(error.error || 'Failed to get upload URL');
        }

        const { uploadUrl, imageUrl } = await res.json();

        const uploadRes = await fetch(uploadUrl, {
            method: 'PUT',
            headers: { 'Content-Type': file.type || 'image/png' },
            body: file,
        });

        if (!uploadRes.ok) {
            throw new Error('S3 upload failed');
        }

        return imageUrl;

    }

    // document.querySelectorAll('.engraving-input').forEach(input => {
    //     const counter = input.nextElementSibling;
    //     if (counter && counter.classList.contains('character-counter')) {
    //         const maxLength = parseInt(input.getAttribute('maxlength')) || 10;
    //         const update = () => {
    //             const remaining = maxLength - input.value.length;
    //             counter.textContent = `${remaining} left`;
    //         };
    //         input.removeEventListener('input', update); // Prevent duplicate listeners
    //         input.addEventListener('input', update);
    //         update(); // Initial call to set text
    //     }
    // });

    // --- Canvas Preview ---
    const previewInput = document.getElementById('preview-name');
    const previewCanvas = document.getElementById('preview-canvas');
    // const previewFontFamily = document.getElementById('preview-font-family').value;
    const previewFontFamilyElement = document.getElementById('preview-font-family');
    const previewFontFamily = previewFontFamilyElement ? previewFontFamilyElement.value : '';
    const previewContainer = previewCanvas ? previewCanvas.closest('.preview-container') : null;

    if (previewInput && previewCanvas && previewContainer) {
        const ctx = previewCanvas.getContext('2d');
        const font = `60px ${previewFontFamily}`;
        console.log(font);
        const shadowColor = 'rgba(0, 0, 0, 0.5)';

        let fillStyle = '#000000'; // Default/fallback color
        const imageUrl = previewContainer.dataset.bgImage;

        if (imageUrl) {
            const image = new Image();
            // crossOrigin is not needed for assets from the same shop
            image.onload = () => {
                // Create a pattern from the loaded image
                fillStyle = ctx.createPattern(image, 'repeat');
                // Redraw the canvas now that the pattern is ready
                redrawCanvas();
            };
            image.onerror = () => {
                console.error('Failed to load image for text pattern.');
                // The fillStyle will remain the fallback color
            };
            image.src = imageUrl;
        }

        const redrawCanvas = () => {
            const text = previewInput.value;

            if (text.length === 0) {
                previewContainer.style.display = 'none';
                return;
            }
            previewContainer.style.display = 'block';

            ctx.font = font;
            const textWidth = ctx.measureText(text).width;
            const newWidth = textWidth > 0 ? textWidth + 40 : 550;
            previewCanvas.width = newWidth;

            // Re-apply styles as resizing clears the context
            ctx.font = font;
            ctx.fillStyle = fillStyle; // Use the pattern or the fallback color
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.shadowColor = shadowColor;
            ctx.shadowOffsetX = 1;
            ctx.shadowOffsetY = 1;
            ctx.shadowBlur = 2;
            ctx.fillText(text, previewCanvas.width / 2, previewCanvas.height / 2);
        };

        previewInput.addEventListener('input', redrawCanvas);

        // Initial draw
        redrawCanvas();
    }




    // Function to validate required fields
    function validateRequiredFields() {
        let isValid = true;
        let firstError = null;

        // Remove existing error messages
        document.querySelectorAll('.field-error').forEach(el => el.remove());
        document.querySelectorAll('.option-item').forEach(el => el.classList.remove('has-error'));

        // Check if group is selected
        const countSelect = document.getElementById('inscription-count');
        const isGroupSelected = countSelect && parseInt(countSelect.value) > 0;

        // Check all required fields (those with a required-asterisk)
        document.querySelectorAll('.required-asterisk').forEach(asterisk => {
            const fieldWrapper = asterisk.closest('.option-item');
            if (!fieldWrapper) return;

            // 跳过未选中的 bundle 产品
            const bundleProduct = fieldWrapper.closest('.bundle-product');
            if (bundleProduct) {
                const checkbox = bundleProduct.querySelector('.bundle-item-checkbox');
                if (checkbox && !checkbox.checked) return; // 未选中则跳过验证
            }

            // Skip validation for hidden standalone stone fields when group is selected
            if (isGroupSelected) {
                const birthstoneSelector = fieldWrapper.querySelector('.birthstone-selector');
                if (birthstoneSelector && !birthstoneSelector.closest('.birthstone-group')) {
                    return; // Skip validation for standalone stone selectors when group is selected
                }
            }

            // Skip validation for hidden fields
            if (fieldWrapper.style.display === 'none' ||
                fieldWrapper.offsetParent === null) {
                return;
            }

            // Find the input/select within this field
            const input = fieldWrapper.querySelector('input, select, textarea');
            if (!input) return;

            // Photo upload fields are satisfied once a preview image exists,
            // even if the hidden file input has been reset for re-uploading.
            if (input.type === 'file') {
                const previewImage = fieldWrapper.querySelector('img[id^="design-preview"]');
                const hasPreview = !!(previewImage && previewImage.getAttribute('src'));
                if (hasPreview) {
                    return;
                }
            }

            // Check if the field has a value
            if (!input.value || !input.value.trim()) {
                fieldWrapper.classList.add('has-error');

                // Add error message if not already present
                if (!fieldWrapper.querySelector('.field-error')) {
                    const errorMsg = document.createElement('div');
                    errorMsg.className = 'field-error';
                    errorMsg.textContent = window.ShopifyTranslations.requiredField;
                    fieldWrapper.appendChild(errorMsg);
                }

                // Track first error for focus
                if (!firstError) {
                    firstError = input;
                }

                isValid = false;
            }
        });

        // Focus on first error if any
        if (firstError) {
            firstError.focus();
        }

        return isValid;
    }

    // Add click handler to all add to cart buttons
    document.querySelectorAll('[name="add"]').forEach(button => {
        console.log(document.querySelectorAll('[name="add"]'))
        button.addEventListener('click', async function (e) {
            console.log('123')
            // Only prevent default if validation fails
            if (!validateRequiredFields()) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
            // If validation passes, the form will submit normally
            // If this is a bundle product, use our custom handler

            if (document.querySelector('.bundle-products-container')) {
                e.preventDefault();
                e.stopPropagation();
                await addBundleItemsToCart(e);
                return false;
            }


            // 获取当前页面URL
            const visitUrl = window.location.href;

            // 从localStorage获取或生成tag_id
            let tagId = document.cookie.split('; ').find(row => row.startsWith('_shopify_y='));
            if (tagId) {
                tagId = tagId.split('=')[1];
            }

            // 获取AdditionalData
            const additionalDataInput = document.getElementById('AdditionalData');
            const jsonData = additionalDataInput ? JSON.parse(additionalDataInput.value || '{}') : {};

            // 生成时间戳和签名
            const timestamp = Date.now();
            const signature = await generateSignature(timestamp);

            let sku = document.getElementById('current_sku').value;

            console.log('12345678')
            const hasCustomization = document.querySelector('.product-personalization-container') &&
                document.querySelector('.product-personalization-container').children.length > 2
            if (hasCustomization) {
                try {
                    const response = await fetch('https://shopify-cart-info.gnoce.com/default/shopifyAddCartInfo', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            visit_url: visitUrl,
                            tag_id: tagId,
                            sku: sku,
                            json_data: jsonData,
                            timestamp: timestamp,
                            signature: signature
                        })
                    });

                    if (!response.ok) {
                        console.error('Failed to send tracking data');
                    }
                } catch (error) {
                    console.error('Error sending tracking data:', error);
                }
            }
        });
    });

    async function addBundleItemsToCart(event) {
        event.preventDefault();
        // 获取所有选中的捆绑商品
        const allBundleItems = document.querySelectorAll('.bundle-item-checkbox');
        const selectedCheckboxes = document.querySelectorAll('.bundle-item-checkbox:checked');
        const isAllSelected = allBundleItems.length > 0 && selectedCheckboxes.length === allBundleItems.length;
        // 从容器读取折扣率并计算折扣百分比
        const container = document.querySelector('.bundle-products-container');
        const discountRate = parseFloat(container?.dataset.discountRate || 0.95);
        const discountPercentage = (1 - discountRate).toFixed(2);

        const selectedItems = Array.from(document.querySelectorAll('.bundle-item-checkbox:checked'))
            .map(checkbox => {
                const product = checkbox.closest('.bundle-product');
                const sizeSelect = product.querySelector('.ring-size-select');
                // const isDiscountApplied = checkbox.checked;
                console.log('isDiscountApplied')
                return {
                    id: product.dataset.productId,
                    variantId: product.dataset.variantId || product.querySelector('[name="id"]')?.value,
                    quantity: 1,
                    properties: {
                        _bundle: 'true',
                        _discount_percentage: isAllSelected ? discountPercentage : 0,
                    },
                    properties: {
                        _Additional_Data: product.dataset.productAdditionalData
                    }
                };
            })
            .filter(item => item.variantId);

        if (selectedItems.length === 0) {
            alert('请至少选择一个产品');
            return;
        }

        const button = event.target.closest('[name="add"]');
        const form = button ? button.closest('form') : null;
        const originalText = button ? button.innerHTML : '';
        // 获取fake按钮元素
        const fakeSubmitBtn = document.querySelector('#ProductSubmitBtn-fake');

        // 显示两个按钮的加载状态
        if (button) {
            button.disabled = true;
            button.innerHTML = '添加中...';
        }
        // 激活fake按钮的加载状态
        if (fakeSubmitBtn) {
            fakeSubmitBtn.classList.add('loading');
            fakeSubmitBtn.querySelector('.loading__spinner')?.classList.remove('hidden');
        }

        try {
            // 逐个将商品添加到购物车
            for (const item of selectedItems) {
                const isDiscountApplied = item.properties._discount_percentage > 0;
                const formData = new FormData();
                formData.append('id', item.variantId);
                formData.append('quantity', item.quantity);
                formData.append('properties[_bundle]', 'true');
                if (isAllSelected) {
                    formData.append('properties[_discount_percentage]', discountPercentage);
                }
                formData.append('properties[_Additional_Data]', item.properties._Additional_Data);

                // 如果有尺寸选择，添加尺寸信息
                const sizeSelect = document.querySelector(`.bundle-product[data-product-id="${item.id}"] .ring-size-select`);
                if (sizeSelect && sizeSelect.value) {
                    formData.append('properties[Size]', sizeSelect.options[sizeSelect.selectedIndex].text);
                }

                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    body: formData
                });

                if (!response.ok) {
                    throw new Error('添加商品到购物车失败');
                }
            }

            // 所有商品添加完成后，刷新购物车抽屉
            try {
                // 强制刷新购物车数据
                const cartResponse = await fetch('/cart.js');
                const cart = await cartResponse.json();

                // 更新购物车数量
                const cartCount = document.querySelector('.header__icon--cart .cart-count-bubble');
                if (cartCount) {
                    cartCount.textContent = cart.item_count;
                }

                // 购物车刷新方法
                await refreshCartUI();

                // 打开购物车抽屉
                const cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                if (cartDrawer) {
                    // 直接调用组件的打开方法（如果存在）
                    if (typeof cartDrawer.open === 'function') {
                        cartDrawer.open();
                    } else {
                        // 设置open属性
                        const details = cartDrawer.querySelector('details');
                        if (details) {
                            details.setAttribute('open', 'true');
                        } else {
                            // 最后点击购物车图标
                            const cartIcon = document.querySelector('.header__icon--cart, .header__icon--cart-count');
                            if (cartIcon) {
                                cartIcon.click();
                            }
                        }
                    }
                }

            } catch (refreshError) {
                console.error('刷新购物车时出错:', refreshError);
            }

        } catch (error) {
            console.error('添加到购物车时出错:', error);
            alert('An error occurred while adding an item to your cart. Please try again.');
        } finally {
            // 恢复按钮状态
            if (button) {
                button.disabled = false;
                button.innerHTML = originalText;
            }
            // 移除fake按钮的加载状态
            if (fakeSubmitBtn) {
                fakeSubmitBtn.classList.remove('loading');
                fakeSubmitBtn.querySelector('.loading__spinner')?.classList.add('hidden');
            }
        }
    }

    // 刷新购物车UI
    async function refreshCartUI() {
        try {
            // 1获取购物车容器并重新加载内容
            const cartContainer = document.querySelector('.cart__contents, [data-cart-container]');
            if (cartContainer) {
                // 保存当前滚动位置
                const scrollPos = cartContainer.scrollTop;

                // 加载最新的购物车HTML
                const response = await fetch('/cart?view=mini');
                if (response.ok) {
                    const html = await response.text();
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = html;

                    // 提取购物车内容并替换
                    const newContent = tempDiv.querySelector('.cart__contents, [data-cart-container]');
                    if (newContent) {
                        cartContainer.innerHTML = newContent.innerHTML;
                        cartContainer.scrollTop = scrollPos; // 恢复滚动位置
                    }
                }
            }

            // 数量输入框事件
            const quantityInput = document.querySelector('form.cart__contents input.quantity__input');
            if (quantityInput) {
                quantityInput.dispatchEvent(new Event("change", {
                    bubbles: true,
                }));
            }
            if (window.updateCart) {
                window.updateCart();
            }

        } catch (error) {
            console.error('刷新购物车UI时出错:', error);
            throw error; // 传递错误以便上层处理
        }
    }
});
